export default {
  host: process.env.GATSBY_STRAPI_URL
};
